import { Routes, Route } from 'react-router-dom';

import MainLayout from '@layouts/MainLayout';
import Home from '@pages/Home/Home';
import About from '@pages/About/About';
import NosOrigines from '@pages/NosOrigines/NosOrigines';
import Rejoindre from '@pages/Rejoindre/Rejoindre';
import Services from '@pages/Services/Services';
import Partenaire from '@pages/Partenaire/Partenaire';
import Contact from '@pages/Contact/Contact';

/**
 * Central route definitions.
 * All pages render inside <MainLayout> (shared Navbar + Footer).
 */
export default function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="nos-origines" element={<NosOrigines />} />
        <Route path="rejoindre" element={<Rejoindre />} />
        <Route path="services" element={<Services />} />
        <Route path="partenaire" element={<Partenaire />} />
        <Route path="contact" element={<Contact />} />
        {/* Add more routes here as needed */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

/* ---- Minimal 404 ---- */
function NotFound() {
  return (
    <section className="container section" style={{ textAlign: 'center' }}>
      <h1>404</h1>
      <p>Sorry, the page you're looking for doesn't exist.</p>
    </section>
  );
}
